export default __webpack_public_path__ + "cdf27d1a870171e7652e2966886ea484.png";